export default function Gallery({ content, images }) {
  const sec = content?.gallery_section || {};
  const list = images && images.length > 0 ? images : [];
  const REPEATS = 8;
  const tracks = Array.from({ length: REPEATS }, () => list).flat();

  return (
    <section id="galeria" className="relative py-20 md:py-28 overflow-hidden" data-testid="gallery-section">
      <div className="absolute inset-0 bg-stripes-blue-soft opacity-50" />

      <div className="relative max-w-7xl mx-auto px-5 md:px-8 text-center mb-14">
        <span className="inline-block font-display text-sm font-semibold tracking-[0.2em] uppercase mb-4" style={{ color: "var(--ff-peach)" }}>
          {sec.eyebrow || "Galeria"}
        </span>
        <h2 className="title-pop text-4xl md:text-6xl mb-4" style={{ color: "var(--ff-text)" }}>
          {sec.title || "Momentos Fantasticfun"}
        </h2>
        <p className="max-w-xl mx-auto text-base md:text-lg font-body" style={{ color: "var(--ff-text-soft)" }}>
          {sec.subtitle}
        </p>
      </div>

      <div className="relative marquee-wrapper" data-testid="gallery-marquee">
        <div className="marquee-track">
          {tracks.map((img, idx) => (
            <div
              key={`${img.id || idx}-${idx}`}
              className="shrink-0 w-72 md:w-96 hover-zoom"
              data-testid={`gallery-image-${idx}`}
            >
              <div className="relative">
                <div className="absolute top-3 left-3 z-10 bg-white/90 backdrop-blur-sm rounded-full w-8 h-8 flex items-center justify-center font-display font-bold text-sm shadow-lg" style={{ color: "var(--ff-peach)" }}>
                  {img.order || idx + 1}
                </div>
                <div
                  className="rounded-3xl overflow-hidden border-[6px] aspect-[4/5] hover-zoom-img bg-white"
                  style={{ borderColor: idx % 2 === 0 ? "var(--ff-peach)" : "var(--ff-sky)" }}
                >
                  <img
                    src={img.image_url}
                    alt={img.caption || "Galeria"}
                    className="w-full h-full object-cover"
                    loading="lazy"
                    onError={(e) => { e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect fill='%23f1f5f9' width='400' height='300'/%3E%3Ctext fill='%2394a3b8' font-family='sans-serif' font-size='16' x='200' y='150' text-anchor='middle' dominant-baseline='middle'%3ESem imagem%3C/text%3E%3C/svg%3E"; }}
                  />
                </div>
              </div>
              <div className="bg-white/95 backdrop-blur-sm rounded-2xl p-3 mt-2 shadow-md">
                <p className="text-center font-display font-semibold text-sm md:text-base" style={{ color: "var(--ff-text)" }}>
                  {img.caption || <span className="text-slate-400 italic">Sem legenda</span>}
                </p>
                {img.order !== undefined && (
                  <p className="text-center text-xs mt-1" style={{ color: "var(--ff-peach)" }}>
                    #{img.order}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>

        <div
          className="pointer-events-none absolute top-0 bottom-0 left-0 w-24 md:w-40 z-10"
          style={{ background: "linear-gradient(to right, var(--ff-cream), transparent)" }}
        />
        <div
          className="pointer-events-none absolute top-0 bottom-0 right-0 w-24 md:w-40 z-10"
          style={{ background: "linear-gradient(to left, var(--ff-cream), transparent)" }}
        />
      </div>
    </section>
  );
}
